import React, { useState, useEffect } from "react";
import { getLogs } from "../api";
import { HiOutlineArrowLeft, HiOutlineRefresh, HiOutlineDatabase, HiOutlineExclamationCircle, HiOutlineCheckCircle } from "react-icons/hi";

function Logs({ onBack }) {
  const [logs, setLogs] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const fetchLogs = async () => {
    setCargando(true);
    setError("");
    try {
      const data = await getLogs();
      setLogs(data);
    } catch (err) {
      setError(err.message || "Error al cargar logs");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div style={{ 
      padding: "2rem 3rem", 
      color: "#334155", 
      width: "100%", 
      height: "100%", 
      overflowY: "auto", 
      boxSizing: "border-box",
      backgroundColor: "#f8fafc",
      fontFamily: "'Inter', system-ui, sans-serif"
    }}>
      {/* Header Section */}
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        marginBottom: "2rem",
        backgroundColor: "white",
        padding: "1.5rem 2rem",
        borderRadius: "16px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
          <button 
            onClick={onBack} 
            style={{ 
              display: "flex", alignItems: "center", gap: "0.5rem",
              padding: "0.75rem 1.25rem", borderRadius: "8px",
              backgroundColor: "#f1f5f9", color: "#475569",
              border: "1px solid #e2e8f0", cursor: "pointer",
              fontWeight: "600", fontSize: "0.9rem", transition: "all 0.2s ease"
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#e2e8f0"; e.currentTarget.style.color = "#0f172a"; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#f1f5f9"; e.currentTarget.style.color = "#475569"; }}
          >
            <HiOutlineArrowLeft size={18} /> Volver
          </button>
          
          <div>
            <h2 style={{ margin: 0, color: "#0f172a", fontSize: "1.5rem", fontWeight: "700", letterSpacing: "-0.025em" }}>
              Registro de Actividad
            </h2>
            <p style={{ margin: "0.25rem 0 0 0", color: "#64748b", fontSize: "0.9rem" }}>
              Historial de ejecuciones automáticas del scraper
            </p>
          </div>
        </div>

        <button 
          onClick={fetchLogs} 
          disabled={cargando}
          style={{ 
            display: "flex", alignItems: "center", gap: "0.5rem",
            padding: "0.75rem 1.5rem", borderRadius: "8px",
            backgroundColor: "#3b82f6", color: "white",
            border: "none", cursor: cargando ? "wait" : "pointer",
            fontWeight: "600", fontSize: "0.9rem", 
            boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.3)",
            transition: "all 0.2s ease",
            opacity: cargando ? 0.7 : 1
          }}
          onMouseOver={(e) => { if(!cargando) e.currentTarget.style.backgroundColor = "#2563eb"; e.currentTarget.style.transform = "translateY(-1px)"; }}
          onMouseOut={(e) => { if(!cargando) e.currentTarget.style.backgroundColor = "#3b82f6"; e.currentTarget.style.transform = "translateY(0)"; }}
        >
          <HiOutlineRefresh size={18} style={{ animation: cargando ? "spin 1s linear infinite" : "none" }} /> 
          {cargando ? "Actualizando..." : "Actualizar"}
        </button>
      </div>

      {error && (
        <div style={{ 
          backgroundColor: "#fef2f2", color: "#991b1b", padding: "1rem 1.5rem", 
          borderRadius: "8px", borderLeft: "4px solid #ef4444", marginBottom: "2rem",
          display: "flex", alignItems: "center", gap: "0.75rem", fontWeight: "500"
        }}>
          <HiOutlineExclamationCircle size={24} />
          {error}
        </div>
      )}

      {/* Table Section */}
      <div style={{ 
        backgroundColor: "white", 
        borderRadius: "16px", 
        overflow: "hidden",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025)",
        border: "1px solid #f1f5f9"
      }}>
        {logs.length === 0 && !cargando ? (
          <div style={{ padding: "4rem", textAlign: "center", color: "#94a3b8" }}>
            <HiOutlineDatabase size={48} style={{ marginBottom: "1rem", opacity: 0.5 }} />
            <h3 style={{ margin: 0, color: "#475569" }}>No hay registros</h3>
            <p style={{ marginTop: "0.5rem" }}>Aún no se ha ejecutado el scraper o no ha dejado logs.</p>
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
            <thead>
              <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                <th style={{ padding: "1.25rem 1.5rem", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>ID</th>
                <th style={{ padding: "1.25rem 1.5rem", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Fecha y Hora</th>
                <th style={{ padding: "1.25rem 1.5rem", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Estado</th>
                <th style={{ padding: "1.25rem 1.5rem", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Mensaje</th>
                <th style={{ padding: "1.25rem 1.5rem", textAlign: "center", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Creadas</th>
                <th style={{ padding: "1.25rem 1.5rem", textAlign: "center", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Actualizadas</th>
                <th style={{ padding: "1.25rem 1.5rem", textAlign: "center", color: "#64748b", fontWeight: "600", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Errores</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={log.id} style={{ 
                  borderBottom: index === logs.length - 1 ? "none" : "1px solid #f1f5f9",
                  transition: "background-color 0.15s ease",
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f8fafc"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                >
                  <td style={{ padding: "1.25rem 1.5rem", color: "#94a3b8", fontWeight: "500" }}>#{log.id}</td>
                  <td style={{ padding: "1.25rem 1.5rem", color: "#334155", fontWeight: "500", whiteSpace: "nowrap" }}>
                    {log.fecha}
                  </td>
                  <td style={{ padding: "1.25rem 1.5rem" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: "0.375rem",
                      padding: "0.375rem 0.75rem",
                      borderRadius: "9999px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      letterSpacing: "0.025em",
                      backgroundColor: log.tipo === "error" ? "#fef2f2" : log.tipo === "warning" ? "#fffbeb" : "#f0fdf4",
                      color: log.tipo === "error" ? "#ef4444" : log.tipo === "warning" ? "#f59e0b" : "#10b981",
                      border: `1px solid ${log.tipo === "error" ? "#fecaca" : log.tipo === "warning" ? "#fde68a" : "#bbf7d0"}`
                    }}>
                      {log.tipo === "error" ? <HiOutlineExclamationCircle size={14} /> : <HiOutlineCheckCircle size={14} />}
                      {log.tipo.toUpperCase()}
                    </span>
                  </td>
                  <td style={{ padding: "1.25rem 1.5rem", color: "#475569", lineHeight: "1.5" }}>{log.mensaje}</td>
                  
                  <td style={{ padding: "1.25rem 1.5rem", textAlign: "center" }}>
                    <span style={{ 
                      fontWeight: log.creadas > 0 ? "700" : "500", 
                      color: log.creadas > 0 ? "#10b981" : "#cbd5e1" 
                    }}>
                      {log.creadas}
                    </span>
                  </td>
                  <td style={{ padding: "1.25rem 1.5rem", textAlign: "center" }}>
                    <span style={{ 
                      fontWeight: log.actualizadas > 0 ? "700" : "500", 
                      color: log.actualizadas > 0 ? "#3b82f6" : "#cbd5e1" 
                    }}>
                      {log.actualizadas}
                    </span>
                  </td>
                  <td style={{ padding: "1.25rem 1.5rem", textAlign: "center" }}>
                    <span style={{ 
                      fontWeight: log.errores > 0 ? "700" : "500", 
                      color: log.errores > 0 ? "#ef4444" : "#cbd5e1" 
                    }}>
                      {log.errores}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default Logs;
